var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import UiButton from 'ui/v1/controls/UiButton.vue';
import { PlaceholderHelper } from '../../../packages/email/PlaceholderHelper';
import Icon from 'common/UIToolKit/Icon.vue';
import UiRichTextEditor from '../controls/editors/UiRichTextEditor.vue';
import isNil from 'common/support/isNil';
import BallLoader from 'ui/v1/loaders/BallLoader.vue';
var TemplateEditor = /** @class */ (function (_super) {
    __extends(TemplateEditor, _super);
    function TemplateEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contents = null;
        _this.bufferedContents = null;
        _this.placeholders = [
            {
                label: 'settings.emails.templates.placeholders.talent',
                type: 'talent.name',
            },
        ];
        _this.placeholderHelper = new PlaceholderHelper();
        _this.quill = null;
        return _this;
    }
    TemplateEditor.prototype.created = function () {
        this.placeholderHelper.setPlaceholders(this.placeholders, this.$t.bind(this));
    };
    TemplateEditor.prototype.editorReady = function (quill) {
        var _this = this;
        this.quill = quill;
        // Strip child spans when pasting
        quill.clipboard.addMatcher('.ql-template-placeholder', function (node) { return _this.placeholderHelper.pasteAllowedDelta(node); });
        // Convert not-allowed placeholders to allowed placeholders
        quill.clipboard.addMatcher('.ql-template-placeholder-not-allowed', function (node) { return _this.placeholderHelper.pasteAllowedDelta(node); });
    };
    TemplateEditor.prototype.addPlaceholder = function (placeholder) {
        var selection = this.quill.getSelection(true);
        this.quill.insertEmbed(selection.index, 'TemplatePlaceholderEmbed', { type: placeholder.type, text: this.$t(placeholder.label) });
        this.quill.setSelection(selection.index + placeholder.label.length);
    };
    TemplateEditor.prototype.editorChange = function (ctx) {
        this.$emit('input', ctx.html);
    };
    TemplateEditor.prototype.focus = function () {
        this.quill.focus();
    };
    TemplateEditor.prototype.onValueChanged = function (value) {
        this.contents = value;
    };
    TemplateEditor.prototype.onLoading = function (newVal, oldVal) {
        if (newVal === oldVal) {
            return;
        }
        // when loading starts
        if (newVal) {
            this.bufferedContents = this.contents;
            this.contents = null;
        }
        // when loading ends
        if (!newVal) {
            this.contents = this.bufferedContents;
            this.bufferedContents = null;
        }
    };
    TemplateEditor.prototype.onGptDraft = function (newVal, oldVal) {
        if (newVal == oldVal || isNil(this.gptDraftBody) || isNil(this.quill)) {
            return;
        }
        this.contents = newVal;
        this.quill.setText(newVal);
        this.$emit('gptBodyParsed', this.contents.toString());
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], TemplateEditor.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], TemplateEditor.prototype, "gptDraftBody", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TemplateEditor.prototype, "loading", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TemplateEditor.prototype, "disabled", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TemplateEditor.prototype, "isAiGenerated", void 0);
    __decorate([
        Watch('value', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TemplateEditor.prototype, "onValueChanged", null);
    __decorate([
        Watch('loading'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], TemplateEditor.prototype, "onLoading", null);
    __decorate([
        Watch('gptDraftBody'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], TemplateEditor.prototype, "onGptDraft", null);
    TemplateEditor = __decorate([
        Component({
            components: {
                BallLoader: BallLoader,
                Icon: Icon,
                ValidationProvider: ValidationProvider,
                UiRichTextEditor: UiRichTextEditor,
                UiButton: UiButton,
            },
        })
    ], TemplateEditor);
    return TemplateEditor;
}(Vue));
export default TemplateEditor;
